module.exports = __webpack_public_path__ + "static/media/individual.e88b600d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/individual.svg
// module id = 449
// module chunks = 0